module.exports = __webpack_public_path__ + "img/002-woman.229286b1.svg";